import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get values() {
        return {
            mobileNav: Boolean,
        }
    }

    static get targets() {
        return [
            'links',
            'button',
        ];
    }

    connect() {
        this.mobileNavValue = false;
    }

    toggleMobileNav() {
        if (this.mobileNavValue) {
            this.linksTarget.classList.remove('hub-list--expanded');
            this.buttonTarget.classList.remove('navigation-hamburger--expanded');
            this.mobileNavValue = false;
        } else {
            this.linksTarget.classList.add('hub-list--expanded');
            this.buttonTarget.classList.add('navigation-hamburger--expanded');
            this.mobileNavValue = true;
        }
    }
}
